<template>
  <div class="font-sans bg-neutrals_background text-neutrals_text min-h-screen flex flex-col">
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <router-link to="/" class="flex items-center gap-3">
          <img src="/brand/getlance-logo.svg" alt="GetLance" class="h-12 w-auto" />
        </router-link>
        <nav class="hidden md:flex items-center gap-6 text-sm font-medium">
          <router-link to="/" class="hover:text-accent transition">Início</router-link>
          <a
            href="mailto:contato@getlance.com.br"
            class="hover:text-accent transition"
          >contato@getlance.com.br</a>
        </nav>
      </div>
    </header>

    <section class="relative min-h-[160px] bg-gradient-to-br from-[#1a1a1a] to-[#2d2d2d] flex items-center justify-center px-4">
      <div class="text-center text-white py-10">
        <h1 class="text-2xl sm:text-3xl font-extrabold tracking-tight">{{ title }}</h1>
        <p v-if="subtitle" class="mt-2 text-sm sm:text-base text-white/80 max-w-2xl mx-auto">
          {{ subtitle }}
        </p>
      </div>
    </section>

    <main class="flex-1 w-full max-w-3xl mx-auto px-4 py-10 sm:py-14">
      <article class="bg-white rounded-2xl shadow-lg border border-black/5 p-6 sm:p-10 text-sm sm:text-base leading-relaxed space-y-6">
        <slot />
      </article>
      <div class="mt-8 flex flex-wrap gap-4 justify-center text-sm">
        <router-link
          v-if="alternateLegalLink"
          :to="alternateLegalLink.to"
          class="text-primary font-medium hover:underline"
        >
          {{ alternateLegalLink.label }}
        </router-link>
        <a
          href="mailto:contato@getlance.com.br"
          class="text-neutrals_text/70 hover:text-primary transition"
        >
          contato@getlance.com.br
        </a>
      </div>
    </main>

    <footer class="border-t border-black/10 bg-white/50 py-6 text-center text-xs text-neutrals_text/60">
      <p>© {{ year }} GetLance — {{ footerNote }}</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LegalPageShell',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    /** { to: '/termos-de-servico', label: 'Termos de serviço' } */
    alternateLegalLink: { type: Object, default: null },
    footerNote: { type: String, default: 'Conectando prestadores e contratantes.' },
  },
  computed: {
    year () {
      return new Date().getFullYear();
    },
  },
};
</script>
